import { message } from 'antd';
import { useEffect, useState } from 'react';

interface ICommonAppBridge {
  inApp: boolean;
  inAppClip?: boolean;
  SAFE_AREA_TOP: number;
  SAFE_AREA_BOTTOM: number;
  appVersion: string;
  [key: string]: any;
}

interface IRet {
  inApp: boolean;
  SAFE_AREA_TOP: number;
  appBridge?: ICommonAppBridge;
}

let messageConfigFinished = false;

function useAppBridge(): IRet {
  const [appBridge, setAppBridge] = useState<ICommonAppBridge>();
  const [SAFE_AREA_TOP, setSAFE_AREA_TOP] = useState<number>(0);
  const [inApp, setInApp] = useState<boolean>(false);

  useEffect(() => {
    if ((window as any).inApp) {
      setInApp(true);
    }

    if ((window as any).appBridge) {
      setAppBridge(window.appBridge);
      setSAFE_AREA_TOP(window.appBridge.SAFE_AREA_TOP);
      setInApp(true);

      if (window.appBridge.SAFE_AREA_TOP && !messageConfigFinished) {
        message.config({
          // @ts-expect-error ant version
          top: `${window.appBridge.SAFE_AREA_TOP + 8}vw`
        });
        messageConfigFinished = true;
      }
    }
  }, []);

  return { appBridge, SAFE_AREA_TOP, inApp };
}

export default useAppBridge;
